import { render, staticRenderFns } from "./uf_annotation.vue?vue&type=template&id=64ea1a61&scoped=true"
import script from "./uf_annotation.vue?vue&type=script&lang=js"
export * from "./uf_annotation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ea1a61",
  null
  
)

export default component.exports